import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
declare var require: any;
const html2canvas: any = require('html2canvas');
import { Observable } from 'rxjs/Observable';
import {Router} from '@angular/router';
import { ClientesService } from '../../../services/clientes.service'; // Servicio de clientes
import { ContactosService } from '../../../services/contactos.service'; // Servicio de contactos
import { ServiciosService } from '../../../services/servicios.service'; // Servicio de servicios
import { ConfirmacionesService } from '../../../services/confirmaciones.service'; // Servicio de confirmaciones
import { CotizacionesService } from '../../../services/cotizaciones.service'; // Servicio de cotizaciones
import { CatalogosService } from '../../../services/catalogos.service';
import {UsuariosPersonalService} from '../../../services/usuarios-personal.service';
import {UnidadesService} from '../../../services/unidades.service'; // Servicio de catalogos
@Component({
    templateUrl: './buscador.component.html'
})

export class BuscadorComponent implements OnInit{

    keysUsuarios = {
        "JCG":"0KRr4t9xxEbbZrn89GE6u8DFrQx1",
        "ARG":"10cwhpXvBfha2SrZbZQ1gCJ9mBE2",
        "CSB":"2MWF4GLMVLfkHRjzrMm1eWRtFTh2",
        "AAA":"BGPpum4PxHT4mrUaFDAKzjM6b0h1",
        "MMM":"C3E70FxMC4bMRSNHd4q1MVGSmTv1",
        "SSC":"EZCP67LtgdPEb2h2xbfN2wpQIAr1",
        "MGO":"F6ANyblltAeNQYpfvBgQ00B7kdV2",
        "IVH":"G8aeFqUWnFgjz9lJKg95GfTYvmZ2",
        "TSP":"JBct6V4xEaeG3MkmrPHs5b7hkWj1",
        "EPC":"ORRhaLhuotfYFNt3r08yM8Hvt333",
        "HJL":"OpeXPZnydtQNrhRAEwCcNqHw8fh2",
        "ACS":"R6N4jQ7XeIfyqmhaDNVCW9KRHQV2",
        "BNL":"ThNvhoLqNPQKjmy09pC56IuFaUk2",
        "ECR":"UF1ToAc1AjVdnyoaR2hL2ge5STu2",
        "EMA":"UH1PECWUuINHC1iJjaVLusyzuXy2",
        "EAH":"VbjAROJeB7hTFeJoLg8fvqsK8er1",
        "DSA":"Yp9Uri6FWFhaZ6CGJlxLXi52ub13",
        "ARH":"ZEULlirvkLgJdGdZZJ532FU5SFy1",
        "RRR":"cBlcXSX4bodmrDBlfRnHyn0MuSm1",
        "MNF":"cR6SSE7dfnWhdv4hr6NwLpLYzLv2",
        "JSL":"evcs08VuRyOvyhwY8XQePTe18kf1",
        "JVA":"flGjuvlwCkPgNC8CkfhBRzQLaCf2",
        "BRG":"hbpLimiVe3MmyLTJdxtlbi01AZn2",
        "VVR":"iG6tc1c5xZgFmVNnWj4OQ7427Kp1",
        "SMO":"jSJp2um9UMN3nZZiIAsoMFAXexz2",
        "VCL":"jszR9oiR25YOiy37k65uk03le243",
        "DHR":"kPE5FUHxwwdEodmmJqIg4ipW2hc2",
        "AGM":"kTuQOK2N6yY4Zb2BHzeya3jFuT52",
        "AMG":"lcEC06g10gWbEQyzZ749mCS7Nqy1",
        "SBJ":"mL64yuZTxEUNtqMaSomH46LO0fq2",
        "DLB":"mbcjgkDRcZbMMmfqyrdDlEWBdV52",
        "GUS":"nlPhsgznOhbR6XJZO6v1U8d3fcw1",
        "EOJ":"pdLkoij6OPZlPSRhPN9ovfHlssr2",
        "CPW":"r5idQ41qz9gXttDaf2RV2CL4Z313",
        "VDC":"uDt8AzgFocaR3IQ4Hk289v1ble43",
        "KCH":"wfRK0PutgMQin1HBV0VRx4yTD1x1",
        "AMH":"xjWALwvKucXpkUB4Yqud8t0t2em1",
        "JVP":"y3N15ewIGnaAe43Zk0ncjOG4PRt1",
    }

  buscadorActivo:string='clientes';
  busqueda:Observable<any>;
  busquedaCotizaciones:Observable<any>;
  busquedaClientes:Observable<any>;
  busquedaClientesArchivados:Observable<any>;
  busquedaContactos:Observable<any>;
  busquedaConfirmaciones:Observable<any>;
  busqueda_excel:any;
  busquedaServicios:Observable<any>;
    showLoader: boolean = false;
    public listaDeUnidades: Observable<any>;
    public listaParaFiltro:any;
    public listaObj:any;

    public fechaInicial:any;
  public fechaFinal:any;

    private listadoPersonal:any;
    private filteredListadoPersonal:any;
    private filtro:any;
    private filtroUnidades:any;
    public objListOperadores:any;
    public objListUnidades:any;

    busqueda_porID:any;
    busqueda_porID_cotizaciones:any;
    busqueda_porKeyAgente_cotizaciones:any;
    confirmaciones:any;

    idTrostenBusqueda:any = "";
    idTrostenBusquedaCotizacion:any = "";
    keyAgenteBusquedaCotizacion:any = "";

    currentUserIdVentasHubspotCotizaciones: any = "";
    clienteBusquedaPorKeyAgente:any
    objCotizacionesPorKeyAgente:any=[]

    public arr_cotizaciones:any;
    private diaEnMilis = 1000 * 60 * 60 * 24;

    private fechasReporteCotizacionesPorFechaInicio:any = {};
    private rutas_planeadas_txt:any;

    loaderClientes:boolean = false;
    loaderContactos:boolean = false;
    loaderConfirmaciones:boolean = false;
    loaderCotizaciones:boolean = false;
    loaderServicios:boolean = false;

  constructor(
    private clientesService:ClientesService,
    private serviciosService:ServiciosService,
    private ref: ChangeDetectorRef,
    private unidadesService:UnidadesService,
    private usuariosPersonalServce: UsuariosPersonalService,
    private confirmacionesService:ConfirmacionesService,
    private cotizacionesService:CotizacionesService,
    public route:Router,  private catalogosService: CatalogosService,
    private contactosService: ContactosService) {
        this.setBuscador('clientes')
        this.obtenerFechasLimiteIniciales()
    }

    public operadorUnidadDeConfirmacionPorIdTrosten = {
      operador:null, unidad:null, key:'',busqueda:false, idTrosten:'',
    }

    ngOnInit()
    {
        this.listadoPersonal = this.usuariosPersonalServce.obtenerUsuariosPersonal().snapshotChanges().take(1).map((listado:any) => {
            let listadoPersonal = [];
            listado.forEach(personal => {
                const $key = personal.payload.key;
                const data = { $key, ...personal.payload.val() };
                if(data.informacionPersonal && data.informacionDelSistema && data.informacionLaboral)
                {
                    if(data.informacionDelSistema.rolDeUsuario == "Operador" && data.informacionLaboral.estatusPersonal != 'Baja')
                    listadoPersonal.push(data);
                }
            });
            this.showLoader = false;
            this.objListOperadores = listadoPersonal;
            console.log("objListOperadores",this.objListOperadores)

            return listadoPersonal;
        });
        this.filteredListadoPersonal = this.listadoPersonal

        this.listaDeUnidades= this.unidadesService.obtenerUnidades().snapshotChanges().map(unidadesDB =>{
            let arregloUnidades=[];
            unidadesDB.forEach(unidad=>{
                let $key = unidad.payload.doc.id
                let data = { $key,...unidad.payload.doc.data()}
                arregloUnidades.push(data)
            })

            arregloUnidades.sort(function(a, b){
                if(a.clave < b.clave) return -1;
                if(a.clave > b.clave) return 1;
                return 0;
            });
            this.listaObj = arregloUnidades;
            this.listaParaFiltro = JSON.parse(JSON.stringify(this.listaObj))
            console.log("listaObj",arregloUnidades)
            return arregloUnidades
        });
    }
    crearTodasLasCotizacionesFaltantesEnHubspot()
    {
        this.objCotizacionesPorKeyAgente.forEach(cotizacion => {
            if(cotizacion.idNegocioHubSpot==null)
            {
                this.crearNegocioHubspotMultiple(cotizacion)
            }
        })
    }
    crearNegocioHubspotMultiple(cotizacion)
    {
        var datosParaHubSpot = this.setUpHubSpotAmountAndDates(cotizacion)
        this.clienteBusquedaPorKeyAgente = this.clientesService.obtenerCliente(cotizacion.cliente).snapshotChanges().take(1)
            .map(cliente => {
                const $key = cliente.payload.key;
                const data = { $key, ...cliente.payload.val() };
                return data;
            });

        const infoCliente = {
            idCliente: cotizacion.cliente,
            nombreCliente: cotizacion.nombreCliente,
            idHubspotCliente: cotizacion.idHubspotCliente,
            metodoDeCotizacion: cotizacion.metodoDeCotizacion,
            tipoCliente: cotizacion.tipoCliente,
            puntoOrigen: cotizacion.puntoOrigen ? cotizacion.puntoOrigen : '',
        };
        this.clienteBusquedaPorKeyAgente.subscribe(cliente => {
            this.cotizacionesService.crearCotizacionHubSpot(cotizacion.$key, cotizacion, this.currentUserIdVentasHubspotCotizaciones, datosParaHubSpot.totalCotizado,datosParaHubSpot.forcedMidnighInicioDeServicioFecha,datosParaHubSpot.forcedMidnighFinDeServicioFecha,datosParaHubSpot.info_servicio,infoCliente).take(1).subscribe(res2 => {
                var idHubSpot = res2["id"];
                this.cotizacionesService.editarIdNegocioHubspot(cotizacion.$key, this.keyAgenteBusquedaCotizacion, idHubSpot);
                cotizacion.idNegocioHubSpot = idHubSpot
                console.log("Finished: ",cotizacion.$key+"_"+idHubSpot)
            })
        });
    }
    crearNegocioHubspot(cotizacion)
    {
        console.log("cotizacion",cotizacion)
        var datosParaHubSpot = this.setUpHubSpotAmountAndDates(cotizacion)
        this.clienteBusquedaPorKeyAgente = this.clientesService.obtenerCliente(cotizacion.cliente).snapshotChanges().take(1)
            .map(cliente => {
                const $key = cliente.payload.key;
                const data = { $key, ...cliente.payload.val() };
                return data;
            });
        // Obtiene los contactos del cliente
        this.clienteBusquedaPorKeyAgente.subscribe(cliente => {

            console.log("cotizacion",cotizacion)
            console.log("datosParaHubSpot",datosParaHubSpot)
            console.log("cliente",cliente)
            const infoCliente = {
                idCliente: cotizacion.cliente,
                nombreCliente: cotizacion.nombreCliente,
                idHubspotCliente: cotizacion.idHubspotCliente,
                metodoDeCotizacion: cotizacion.metodoDeCotizacion,
                tipoCliente: cotizacion.tipoCliente,
                puntoOrigen: cotizacion.puntoOrigen ? cotizacion.puntoOrigen : '',
            };
            this.cotizacionesService.crearCotizacionHubSpot(cotizacion.$key, cotizacion, this.currentUserIdVentasHubspotCotizaciones, datosParaHubSpot.totalCotizado,datosParaHubSpot.forcedMidnighInicioDeServicioFecha,datosParaHubSpot.forcedMidnighFinDeServicioFecha, infoCliente ,datosParaHubSpot.info_servicio).take(1).subscribe(res2 => {
                console.log("res2",res2)
                var idHubSpot = res2["id"];
                this.cotizacionesService.editarIdNegocioHubspot(cotizacion.$key, this.keyAgenteBusquedaCotizacion, idHubSpot);
                cotizacion.idNegocioHubSpot = idHubSpot
                alert("Cotización creada en Hubspot Correctamente")
            })
        });
    }
    setUpHubSpotAmountAndDates(cotizacion_o_confirmacion)
    {
        var servicio = {}
        for (var idServicio in cotizacion_o_confirmacion.servicios) {
            servicio = cotizacion_o_confirmacion.servicios[idServicio]
        }

        //console.log("servicio setUpHubSpotAmountAndDates",servicio)
        var info_servicio = servicio;
        var totalCotizado = 0
        if(servicio["precioCombinaciones"])
        {
            for (var idCombinacion in servicio["precioCombinaciones"]) {
                totalCotizado = servicio["precioCombinaciones"][idCombinacion]["total"]
            }
        }
        else {
            totalCotizado = servicio["combinacion"]["precio"]
        }

        var dateInicioServicio = new Date(servicio["itinerario"].inicioDeServicio)
        dateInicioServicio.setHours(0);
        dateInicioServicio.setMinutes(0)
        var inicioDeServicioFecha = (dateInicioServicio).toISOString();
        var forcedMidnighInicioDeServicioFecha = inicioDeServicioFecha.replace(inicioDeServicioFecha.substring(inicioDeServicioFecha.indexOf('T'), inicioDeServicioFecha.lastIndexOf(':00:')), 'T00');

        var dateFinServicio = new Date(servicio["itinerario"].finDeServicio)
        dateFinServicio.setHours(0);
        dateFinServicio.setMinutes(0)
        var finDeServicioFecha = (dateFinServicio).toISOString();
        var forcedMidnighFinDeServicioFecha = finDeServicioFecha.replace(finDeServicioFecha.substring(finDeServicioFecha.indexOf('T'), finDeServicioFecha.lastIndexOf(':00:')), 'T00');

        return {info_servicio:info_servicio,totalCotizado:totalCotizado,forcedMidnighInicioDeServicioFecha:forcedMidnighInicioDeServicioFecha,forcedMidnighFinDeServicioFecha:forcedMidnighFinDeServicioFecha}
    }
    buscarCotizacionPorKeyAgente()
    {
        if(this.keyAgenteBusquedaCotizacion!="")
        {
            this.usuariosPersonalServce.obtenerPropiedadDeUsuario(this.keyAgenteBusquedaCotizacion, 'informacionLaboral').valueChanges().take(1).subscribe(infoLaboral=>{
                console.log("infoLaboral", infoLaboral)
                this.currentUserIdVentasHubspotCotizaciones = infoLaboral["idVentasHubspot"];
            });
            this.showLoader = true;
            this.busqueda_porKeyAgente_cotizaciones = this.cotizacionesService.obtenerCotizacionesPorKeyAgente(this.keyAgenteBusquedaCotizacion).snapshotChanges().take(1)
                .map(cotizaciones => {
                    let cotizacionesArr = [];
                    cotizaciones.forEach(cotizacion => {
                        const $key = cotizacion.payload.key;
                        const data = { $key, ...cotizacion.payload.val() };

                        if(data.idNegocioHubSpot==null)
                        cotizacionesArr.push(data);
                    });
                    console.log("cotizacionesArr",cotizacionesArr)
                    this.objCotizacionesPorKeyAgente = cotizacionesArr
                    this.showLoader = false;
                    return cotizacionesArr.reverse();
                });
        }
        else {
            alert("El campo no puede ir vacío")
        }
    }
    buscarCotizacionPorIdTrosten()
    {
        if(this.idTrostenBusquedaCotizacion!="")
        {
            const idSplited = this.idTrostenBusquedaCotizacion.split("-")

            let userKey = ""

            if(idSplited[0] == "CPW")
            {
                userKey = this.keysUsuarios["CPW"]
            }
            else{
                const agentSiglas = idSplited[0].slice(2)
                userKey = this.keysUsuarios[agentSiglas]
            }

            let tablaYear = ""
            if(idSplited[1].slice(0,2) != "24")
            {
                tablaYear = "BackUp20"+idSplited[1].slice(0,2)
            }

            this.showLoader = true;
            //this.busqueda_porID_cotizaciones = this.cotizacionesService.obtenerCotizacionesPorIdTrosten(this.idTrostenBusquedaCotizacion).snapshotChanges().take(1)
            this.busqueda_porID_cotizaciones = this.cotizacionesService.obtenerCotizacionesPorUsuario(userKey,tablaYear).snapshotChanges().take(1)
            .map(cotizaciones => {
                    let cotizacionesArr = [];
                    cotizaciones.forEach(cotizacion => {
                        const $key = cotizacion.payload.key;
                        const data = { $key, ...cotizacion.payload.val() };

                        if(data.idTrosten == this.idTrostenBusquedaCotizacion)
                        cotizacionesArr.push(data);
                    });
                    this.showLoader = false;
                    return cotizacionesArr.reverse();
                });
        }
        else {
            alert("El campo no puede ir vacío")
        }
    }
    buscarConfirmacionPorIdTrosten()
    {
        if(this.idTrostenBusqueda!="")
        {
            
            this.busqueda_porID = this.confirmacionesService.obtenerConfirmacionPorIDTrosten(this.idTrostenBusqueda).snapshotChanges().take(1)
                .map(confirmaciones => {
                    let confirmacionesArr = [];
                    confirmaciones.forEach(confirmacion => {
                        const $key = confirmacion.payload.doc.id;
                        const data = { $key, ...confirmacion.payload.doc.data() };
                        confirmacionesArr.push(data);
                    });
                    console.log("confirmacionesArr",confirmacionesArr)
                    return confirmacionesArr.reverse();
                });
        }
        else {
            alert("El campo no puede ir vacío")
        }

    }
    buscarCotiFSPorIdTrosten()
    {
        if(this.idTrostenBusquedaCotizacion!="")
        {
            //this.showLoader = true;
            this.busqueda_porID_cotizaciones = this.cotizacionesService.obtenerCotizacionesPorIDTrosten(this.idTrostenBusquedaCotizacion).snapshotChanges().take(1)
                .map(cotizaciones => {
                    let cotizacionesArr = [];
                    cotizaciones.forEach(cotizacion => {
                        const $key = cotizacion.payload.doc.id;
                        const data = { $key, ...cotizacion.payload.doc.data() };
                        cotizacionesArr.push(data);
                    });
                    console.log("confirmacionesArr",cotizacionesArr)
                    this.showLoader = false;
                    return cotizacionesArr.reverse();
                });
        }
        else {
            alert("El campo no puede ir vacío")
        }

    }
    seleccionarOperadorParaFicha(operador_y_unidad_para_ficha)
    {
        console.log("operador_y_unidad_para_ficha",operador_y_unidad_para_ficha)
        let operador = operador_y_unidad_para_ficha.operador;
        let unidad =operador_y_unidad_para_ficha.unidad;
        var unidad_aux = {}
        this.listaObj.forEach(function (value,index)
        {
            if(value.clave == unidad.clave)
            {
                unidad_aux = value;
            }
        })

        var operador_aux = {}
        this.objListOperadores.forEach(function (value,index)
        {
            if(value.$key == operador.key)
            {
                operador_aux = value;
            }
        })
        this.operadorUnidadDeConfirmacionPorIdTrosten.unidad = unidad_aux;
        this.operadorUnidadDeConfirmacionPorIdTrosten.operador = operador_aux;
        console.log("this.operadorUnidadDeConfirmacionPorIdTrosten.operador",this.operadorUnidadDeConfirmacionPorIdTrosten.operador)
        console.log("this.operadorUnidadDeConfirmacionPorIdTrosten.unidad",this.operadorUnidadDeConfirmacionPorIdTrosten.unidad)
        this.operadorUnidadDeConfirmacionPorIdTrosten.key = operador_y_unidad_para_ficha.id_confirmacion;
        this.operadorUnidadDeConfirmacionPorIdTrosten.idTrosten = operador_y_unidad_para_ficha.idTrosten;
        this.operadorUnidadDeConfirmacionPorIdTrosten.busqueda = true;
        this.ref.detectChanges();
    }
    buscarConfirmacionPorIdTrostenCorpSchool()
    {
        if(this.idTrostenBusqueda!="")
        {
            this.operadorUnidadDeConfirmacionPorIdTrosten.busqueda = false;
            this.confirmacionesService.getInfoRutaTurismoPorIdTrosten(this.idTrostenBusqueda).take(1).subscribe(res => {
                let rutas;
                console.log("getInfoRutaTurismoPorIdTrosten",res)
                rutas = res as any;
                var rutas_planeadas_txt_aux = []
                rutas.forEach(function (value,index)
                {
                    if(value.operador && value.unidad)
                    {
                        value.operador = JSON.parse(value.operador)
                        value.unidad = JSON.parse(value.unidad)
                        rutas_planeadas_txt_aux.push(value)
                    }
                })
                this.rutas_planeadas_txt = rutas_planeadas_txt_aux
                this.seleccionarOperadorParaFicha(rutas_planeadas_txt_aux[0])
            })

        }
        else {
            alert("El campo no puede ir vacío")
        }

    }

    seleccionarOperador(operador)
    {
        this.operadorUnidadDeConfirmacionPorIdTrosten.operador = operador;
    }
    seleccionarUnidad(unidad)
    {
        this.operadorUnidadDeConfirmacionPorIdTrosten.unidad = unidad;
        console.log("this.operadorUnidadDeConfirmacionPorIdTrosten.unidad",this.operadorUnidadDeConfirmacionPorIdTrosten.unidad)
    }

    verDetalleCliente(id){
        this.route.navigateByUrl('/ventas/detalle-cliente/'+id);
    }
    verDetalleCotizacion(id){
        this.route.navigateByUrl('/ventas/detalle-cotizacion/'+id)
    }
    verDetalleConfirmacion(id){
        this.route.navigateByUrl('/ventas/detalle-confirmacion/'+id)
    }
     private obtenerFechasLimiteIniciales(){
        let hoy = new Date(Date.now()); // momento ahora
        let hoyInicio = hoy.setHours(0,0,0); // Obtiene la hora minima del día
        let hoyFin = hoy.setHours(23,59,59,999); // Obtiene la hora maxima del día
        let diaDeLaSemana = hoy.getDay(); // Obtiene el numero de día de la semana

        // Obtiene los limites de las fechas en milisegundos de acuerdo a la fecha actual
        switch(diaDeLaSemana){
            case 1: // Lunes
                // Fecha inicial sería la de de hoy pero con las horas de inicio
                // A la fecha final hay que sumarle 6 días
                this.fechaInicial = new Date(hoyInicio);
                this.fechaFinal = new Date(hoyFin.valueOf() + (this.diaEnMilis * 6));
                break;
            case 0: // Domingo
                // La fecha final se hace la actual, pero con las horas máximas
                // A la fecha de inicial hay que restarle 7
                this.fechaFinal = new Date(hoyFin);
                this.fechaInicial = new Date(hoyInicio.valueOf() - (this.diaEnMilis * 6));
                break;
            default: // Puede ser cualquier otro día de la semana que no sea lunes ni domingo
                // Se le suman y le restan los dias necesarios para que queden los limites ajustados
                this.fechaInicial = new Date(hoyInicio.valueOf() - (this.diaEnMilis * (diaDeLaSemana - 1)));
                this.fechaFinal = new Date(hoyFin.valueOf() + (this.diaEnMilis * (7 - diaDeLaSemana)));
                break;
        }
    }
    private cambiarSemana(eleccion, buscador){
        let fechaInicialEnMilis = new Date(this.fechaInicial).getTime();
        let fechaFinalEnMilis = new Date(this.fechaFinal).getTime();
        let semanaEnMilis = this.diaEnMilis * 7;

        switch(eleccion){
            case 'anterior':
                this.fechaInicial = new Date(fechaInicialEnMilis - semanaEnMilis);
                this.fechaFinal = new Date(fechaFinalEnMilis - semanaEnMilis);
                break;
            case 'siguiente':
                this.fechaInicial = new Date(fechaInicialEnMilis + semanaEnMilis);
                this.fechaFinal = new Date(fechaFinalEnMilis + semanaEnMilis);
                break;
        }
        this.setBuscador(this.buscadorActivo)
    }

  setBuscador(buscador){
    this.buscadorActivo = buscador;
    //this.showLoader = true;
    
  }

  /**
   * Descarga /clientes y devuelve solo el lado que se pide: los vigentes o los
   * archivados por inactividad (TOM-374).
   *
   * El filtro se hace aca y no con una consulta porque RTDB no puede hacer
   * orderByChild('archivado') sobre un campo que la mayoria de los nodos no
   * tiene. Los archivados conservan su nodo a proposito -- es lo que permite
   * que las referencias viejas de MySQL y de los otros repos sigan
   * resolviendo -- asi que se siguen descargando: esto corrige que aparezcan
   * en la busqueda, no lo que pesa la descarga. Bajar el peso de verdad es
   * mover el buscador a Firestore, y eso va en su propio ticket.
   */
  private cargarClientes(archivados:boolean)
  {
    return this.clientesService.obtenerTodosLosClientes().snapshotChanges().take(1)
    .map(clientes => {
      let clientesArr = [];
      clientes.forEach(cliente => {
        const $key = cliente.payload.key;
        const valor = cliente.payload.val();
        // /clientes tiene algunos nodos basura con valores escalares sueltos.
        if (!valor || typeof valor !== 'object') {
          return;
        }
        // Sin ?. ni ??: TypeScript 2.4. Un nodo sin el campo es vigente.
        if ((valor.archivado === true) !== archivados) {
          return;
        }
        const data = { $key, ...valor };
        clientesArr.push(data);
      });
      this.loaderClientes = false;
      return clientesArr;
    });
  }

  buscar()
  {
    switch (this.buscadorActivo) {
        case 'clientes':
          this.loaderClientes = true;
          this.busquedaClientes = this.cargarClientes(false);
          break;
        case 'clientesArchivados':
          this.loaderClientes = true;
          this.busquedaClientesArchivados = this.cargarClientes(true);
          break;
        case 'contactos':
            this.loaderContactos = true;
          this.busquedaContactos = this.contactosService.obtenerTodosLosContactos().snapshotChanges().take(1)
          .map(contactos => {
            let contactosArr = [];
            contactos.forEach(contacto => {
              const $key = contacto.payload.key;
              const data = { $key, ...contacto.payload.val() };
              contactosArr.push(data);
            });
            
            this.loaderContactos = false;
            return contactosArr.reverse();
          });
          break;
        case 'confirmaciones':
            this.loaderConfirmaciones = true;
          this.busquedaConfirmaciones = this.confirmacionesService.obtenerConfirmacionesEntreFechas(new Date(this.fechaInicial).getTime(),new Date(this.fechaFinal).getTime()).snapshotChanges().take(1)
          .map(confirmaciones => {
            let confirmacionesArr = [];
            confirmaciones.forEach(confirmacion => {
              const $key = confirmacion.payload.doc.id;
              const data = { $key, ...confirmacion.payload.doc.data() };
              confirmacionesArr.push(data);
            });
            this.loaderConfirmaciones = false;
            return confirmacionesArr.reverse();
          });
          break;
        case 'cotizaciones':
            this.loaderCotizaciones = true;
          this.busqueda = this.cotizacionesService.obtenerCotizacionesEntreFEchas(new Date(this.fechaInicial).getTime(),new Date(this.fechaFinal).getTime()).snapshotChanges().take(1)
          //this.busqueda = this.cotizacionesService.obtenerCotizacionesEntreFEchasPorAgente(new Date(this.fechaInicial).getTime(),new Date(this.fechaFinal).getTime(),window.localStorage.getItem("usuario.uid")).snapshotChanges().take(1)
          .map(cotizaciones => {
            let cotizacionesArr = [];
            cotizaciones.forEach(cotizacion => {
              const $key = cotizacion.payload.key;
              const data = { $key, ...cotizacion.payload.val() };
  
                for (var idServicio in data.servicios) {
                    data.id_servicio = idServicio;
                    data.inicioDeServicio = data.servicios[idServicio].itinerario.inicioDeServicio;
                }
  
              cotizacionesArr.push(data);
            });
            this.loaderCotizaciones = false;
            return cotizacionesArr.reverse();
          });
          break;
        default:
          return;
      }
  }

  /**
   * Checa el cambio de fecha
   * @param fecha
   */
  cambioDeFechaServicios(fecha:string){
    this.loaderServicios = true;
    const fechaSeparada = fecha.split('-');
    // Checa que la fecha sea válida y mayor al año 2010 antes de hacer la consulta
    if(fechaSeparada.length == 3 && Number(fechaSeparada[0]) >= 2010){
      const fechaSeleccionada = new Date(Number(fechaSeparada[0]), Number(fechaSeparada[1]) - 1, Number(fechaSeparada[2]));
      const fechaInicial = fechaSeleccionada.setHours(0,0,0).valueOf();
      const fechaFinal = fechaSeleccionada.setHours(23,59,29,999).valueOf();
      this.busquedaServicios = this.serviciosService.obtenerServiciosEntreFechas(fechaInicial, fechaFinal).snapshotChanges().take(1)
      .map(servicios => {
        let serviciosArr = [];
        servicios.forEach(servicio => {
          const $key = servicio.payload.doc.id;
          const data = { $key, ...servicio.payload.doc.data() };
          serviciosArr.push(data);
        });
        this.loaderServicios = false;
        return serviciosArr;
      });
    }
  }

  descargarFichaComoImagen() {
    var elemento = document.getElementById('fichaOperadorCard');
    if (!elemento) { return; }
    var idTrosten = this.operadorUnidadDeConfirmacionPorIdTrosten.idTrosten || 'ficha';
    var fn = html2canvas.default || html2canvas;
    fn(elemento, { useCORS: true, allowTaint: true, scale: 1 }).then(function(canvas) {
      var link = document.createElement('a');
      link.download = 'ficha-operador-' + idTrosten + '.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  }

  getTipoUnidadParaImagen(tipo: string) {
    if (!tipo) { return 'Auto'; }
    if (tipo.includes('Tipo 1')) { return 'CamionetaTipo1'; }
    if (tipo.includes('Tipo 2') && (tipo.includes('Lujo') || tipo.includes('lujo'))) { return 'CamionetaTipo2lujo'; }
    if (tipo.includes('Tipo 2')) { return 'CamionetaTipo2'; }
    if (tipo.includes('Tipo 3')) { return 'CamionetaTipo3'; }
    if (tipo.includes('V-Class') && tipo.includes('extra')) { return 'tipo_camioneta_V-Class%20extra%20larga'; }
    if (tipo.includes('V-Class') && tipo.includes('azul')) { return 'tipo_camioneta_V-Class%20azul'; }
    if (tipo.includes('V-Class') && (tipo.includes('blanca') || tipo.includes('blanco'))) { return 'tipo_camioneta_V-Class%20blanca'; }
    if (tipo.includes('V-Class')) { return 'tipo_camioneta_V-Class%20blanca'; }
    return 'Auto';
  }


    descargar_excel_por_fechaInicio()
    {
        this.showLoader = true;
        let fechaInicial = this.fechasReporteCotizacionesPorFechaInicio.fechaInicial+" 00:00:00";
        let fechaFinal = this.fechasReporteCotizacionesPorFechaInicio.fechaFinal+" 23:59:59";
        var d1 = new Date(fechaInicial).getTime();
        var d2 = new Date(fechaFinal).getTime();

        let busqueda_excel = this.cotizacionesService.obtenerTodasLasCotizaciones()
        busqueda_excel.snapshotChanges().subscribe(cotizaciones=> {
            let cotizacionesArr = [];
            cotizaciones.forEach(cotizacion => {

                const $key = cotizacion.payload.key;
                const data = { $key, ...cotizacion.payload.val() };

                for (var idServicio in data.servicios) {
                    data.id_servicio = idServicio;
                    if(data.servicios[idServicio].itinerario)
                    {
                        data.inicioDeServicio = data.servicios[idServicio].itinerario.inicioDeServicio;
                        data.finDeServicio = data.servicios[idServicio].itinerario.finDeServicio;
                        data.alias_origen = data.servicios[idServicio].origen.alias;
                        data.alias_destino = data.servicios[idServicio].destino.alias;
                    }
                }

                if(data.inicioDeServicio>d1 && data.inicioDeServicio<d2)
                {
                    var coti_aux = {
                        idTrosten:data.idTrosten,
                        f_d_c:data.fechaDeCreacion,
                        f_d_i:data.inicioDeServicio,
                        f_d_f:data.finDeServicio,
                        o:data.alias_origen,
                        d:data.alias_destino,
                        e:data.estatus
                    }
                    cotizacionesArr.push(coti_aux);
                }
            })

            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", "https://operacion.trosten.com/excel-service/reporteCotizacionesPorFechaInicioServicio.php");
            form.setAttribute("target", "name");

            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = "json";
            input.value = JSON.stringify(cotizacionesArr);
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);

            this.showLoader = false;
        });
        /*
                this.busqueda = this.cotizacionesService.obtenerTodasLasCotizaciones().snapshotChanges().take(1)
                    .map(cotizaciones => {
                        let cotizacionesArr = [];
                        cotizaciones.forEach(cotizacion => {
                            const $key = cotizacion.payload.key;
                            const data = { $key, ...cotizacion.payload.val() };

                            for (var idServicio in data.servicios) {
                                data.id_servicio = idServicio;
                                data.inicioDeServicio = data.servicios[idServicio].itinerario.inicioDeServicio;
                            }

                            if(data.inicioDeServicio>d1 && data.inicioDeServicio<d2)
                            {
                                cotizacionesArr.push(data);
                            }
                        });

                        console.log(cotizacionesArr)

                        var form = document.createElement("form");
                        form.setAttribute("method", "post");
                        form.setAttribute("action", "https://trosten.azurewebsites.net/excel-service/reporteCotizacionesPorFechaInicioServicio.php");
                        form.setAttribute("target", "name");

                        var input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = "json";
                        input.value = JSON.stringify(cotizacionesArr);
                        form.appendChild(input);
                        document.body.appendChild(form);
                        form.submit();
                        document.body.removeChild(form);


                        return cotizacionesArr.reverse();
                    });*/
        /* Chequeo de seguridad
        if(fechaInicial > fechaFinal)
            alert('La fecha inicial no puede ser mayor a la final');
        else
        {
            var coded64 = btoa("RfILK889PNZmkBi5trx3ZFPy95Ku2qQKSnRjJC5m");
            window.open("https://trosten.azurewebsites.net/excel-service/reporteCotizacionesPorFechaInicioServicio.php?fInicial="+fechaInicial+"&fechaFinal="+fechaFinal+"&fhrtbxdbtrbrt="+coded64,"_blank")
        }*/
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/buscador/buscador.component.ts